import { useEffect, useState, useRef } from "react";
import "./Dropdown.css";
import { LockIcon, SX_renderpage_tick, Tick_BoxesPLan } from "../../assets/icons";

const Dropdown_render = (props) => {
  const {
    label,
    value,
    onChange,
    options,
    inputBox,
    resolutionIndex,
    isUserPaid,
    style,
    customStyle,
    IsUpgradeOpen,
  } = props;
  const [isOptionsVisible, setIsOptionsVisible] = useState(false);


  let useClickOutside = (handler) => {
    let domNode = useRef();

    useEffect(() => {
      let isHandler = (event) => {
        if (!domNode.current.contains(event.target)) {
          handler();
        }
      };

      document.addEventListener("mousedown", isHandler);

      return () => {
        document.removeEventListener("mousedown", isHandler);
      };
    });

    return domNode;
  };

  let domNode = useClickOutside(() => {
    setIsOptionsVisible(false);
  });

  const handleSelected = (value) => {
    onChange(value);
    setIsOptionsVisible(false);
  };
  let displayValue = value;
  const idx = options?.findIndex((opt) => opt.value === value);
  if (idx !== undefined && idx !== -1) displayValue = options[idx].label;
  return (
    <div className="DDContainer">

      {label && <span className="DD-label">{label}</span>}

      <div ref={domNode} className="DDContainer-component">

        <div className="DdUpBoxLabel"
          style={style}
          onClick={() => setIsOptionsVisible(!isOptionsVisible)}
        >

          <div className="DDbtnContainer">
            {isOptionsVisible ? (
              <span className="DDup-btn">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="icon-tabler icon-tabler-chevron-up "
                width="24"
                height="24"
                viewBox="0 0 24 24"
                stroke-width="2"
                stroke="currentColor"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <polyline points="6 15 12 9 18 15"></polyline>
              </svg>
              </span>
            ) : (
              <span className="DDdown-btn">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="icon-tabler icon-tabler-chevron-down"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                stroke-width="2"
                stroke="currentColor"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
              </span>
            )}
          </div>

          <hr />

          <div className="DDdisplayvalue">
            {inputBox ? (
              <input
                type="number"
                className="dropdownInput"
                value={value}
                onChange={(evt) => {
                  if (onChange) {
                    onChange(evt.target.value);
                  }
                }}
              />
            ) : (
              displayValue
            )}
          </div>

       
        </div>
        {isOptionsVisible && (
            <div className="DD-render-options-Container" style={customStyle}>
              {options?.map((option, ind) => (
                <div
                  id="resolutionDropdown"
                  className="dropdown-renderList-1"
                  onClick={() => isUserPaid || ind === 0 ? handleSelected(option.value) : IsUpgradeOpen(true) }
                >
                  <div
                    className={
                      "dropdown-label-render" +
                      (ind === resolutionIndex
                        ? " dropdown-label-render-selected"
                        : "")
                    }
                  >
                    {!isUserPaid && ind !== 0 ? (
                      <div className="flex">
                        <img
                          className="pr-2 w-[20px] py-[2px] h-[20px]"
                          src={LockIcon}
                          alt="LockIcon"
                        />
                        <div>{option.label}</div>
                      </div>
                    ) : (
                      <div className="flex">
                        <img className="pr-2 w-[25px] py-[2px] h-[18px] " src={SX_renderpage_tick} alt="" />
                        <div>
                        {option.label}
                        </div>
                      </div>
                    )}
                  </div>
                  <hr className="dropdown-hr" />
                </div>
              ))}
            </div>
          )}
      </div>
    </div>
  );
};
export default Dropdown_render;
